<template>
  <div class="p-3 border border-dark">
    <p class="text-success text-center">
      <small>
        <strong
          >You may already be registered with us. Do you have the Hunter & Gold App installed?</strong
        ></small
      >
    </p>
    <div class="pl-5 form-check col-sm-3">
      <input
        class="form-check-input"
        type="radio"
        name="inlineRadioOptions"
        id="inlineRadio1"
        value="option1"
        @click="showRegistered = true"
      />
      <label class="form-check-label form-control-sm" for="inlineRadio1"
        >Yes</label
      >
    </div>
    <div class="form-check col-sm-3">
      <input
        class="form-check-input"
        type="radio"
        name="inlineRadioOptions"
        id="inlineRadio2"
        value="option2"
        @click="notRegistered()"
      />
      <label class="form-check-label form-control-sm" for="inlineRadio2"
        >No</label
      >
    </div>
    <template v-if="showRegistered">
       <p class="text-success text-center">
        <small>
          <strong
            >What is your registered email? So that we can link your guest pass to your H&G account.</strong
          ></small
        >
      </p>

      <Form
        @submit="findRegisteredUser"
        :validation-schema="schema"
        id="find_form"
      >
        <div class="form-group">
          <label for="email" class="form-control-sm">Your Email</label>
          <Field
            name="email"
            type="text"
            class="form-control form-control-sm"
          />
          <ErrorMessage name="email" class="error-feedback" />
        </div>

        <div class="form-group text-center mt-2">
          <button
            class="btn btn-dark btn-block text-white"
            type="submit"
            @click="submit"
          >
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>

            <span>Link Guest Pass </span>
            <font-awesome-icon icon="chevron-right" />
          </button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
    </template>
  </div>
</template>
       


<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import GuestService from "../services/guest.service";
import LinkedGuestPass from './LinkedGuestPass.vue'
import * as yup from "yup";
import $ from "jquery";

export default {
  name: "RegisteredUser",
  props: ["guest"],

  components: {
    Form,
    Field,
    ErrorMessage,
    LinkedGuestPass
  },

  setup(props, { emit }) {
    
    const handleSignUp = (newVal) => {
      console.log(newVal);
      emit("signupEvent", newVal);
    };

    return { handleSignUp };
  },

  mounted() {},
  data() {
    const schema = yup.object().shape({
      email: yup.string().email().required("Email is required"),
    });

    return {
      loading: false,
      message: "",
      schema,
      guest_id: parseInt(this.guest),
      showRegistered: false,
    };
  },

  methods: {
    notRegistered() {
      this.showRegistered = false;
      this.handleSignUp(true);
    },
    //validate(user) {
    //   if (user.email == null) {
    //     this.message = "Please provide the email you registered with";
    //   } else {
    //     this.findRegisteredUser(user);
    //   }
    // },

    findRegisteredUser(user) {
      var self = this;
      this.loading = true;

      GuestService.findByEmail(user).then(
        (response) => {
          this.message = "";
          this.loading = false;
          // Registered User Found
          self.updateInvitation(response[0].id);
        },
        (error) => {
          this.loading = false;
          this.message = "";

          if (error.response.status === 404) {
            // Guest Pass Sign Up, no matches found
            self.handleSignUp(false);
          } else {
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.detail) ||
              error.response.data.detail ||
              error.toString();
          }
        }
      );
    },

    updateInvitation(user_id) {
      GuestService.updateGuest(user_id, this.guest_id, true).then(
        (response) => {
          this.message = "";
          this.loading = false;
          this.$router.push({ name: 'LinkedGuestPass', params: { linked: true } })
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.toString();
        }
      );
    },
    resetForm() {
      $("#find_form")[0].reset();
      this.imagesArray = null;
      this.img = null;
    },
  },
};
</script>
 
<style scoped>
.btn:focus {
  outline: none;
  box-shadow: none;
}

button {
  margin-top: 10px;
}
label {
  display: block;
  margin-top: 10px;
}

.register {
  background-color: #a18140;
  margin: 10px;
  border: none !important;
  box-shadow: none !important;
  outline: 0 none !important;
}

.error-feedback {
  color: red;
}

label {
  font-weight: bold;
  margin: 5px;
}

p {
  text-indent: 5px;
}

.signup_title {
  margin-top: 10px;
  font-weight: bold;
  color: green;
}
</style>